import { render } from "./info-project.vue?vue&type=template&id=516a548a&scoped=true&ts=true"
import script from "./info-project.vue?vue&type=script&lang=ts"
export * from "./info-project.vue?vue&type=script&lang=ts"

import "./info-project.vue?vue&type=style&index=0&id=516a548a&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516a548a"]])

export default __exports__